// Dynamic imports for quotes
const loadQuotes = async (language) => {
  try {
    const module = await import(`./${language}.js`)
    return module.quotes
  } catch (error) {
    console.warn(`Failed to load quotes for ${language}, falling back to zh-CN`)
    const fallback = await import('./zh-CN.js')
    return fallback.quotes
  }
}

// Static imports for immediate availability
import { quotes as zhQuotes } from './zh-CN.js'
import { quotes as enQuotes } from './en-US.js'
import { quotes as jaQuotes } from './ja-JP.js'
import { quotes as esQuotes } from './es-ES.js'
import { quotes as frQuotes } from './fr-FR.js'
import { quotes as deQuotes } from './de-DE.js'
import { quotes as koQuotes } from './ko-KR.js'
import { quotes as ptQuotes } from './pt-BR.js'
import { quotes as ruQuotes } from './ru-RU.js'
import { quotes as itQuotes } from './it-IT.js'

// Pre-loaded quotes for instant access
export const quotes = {
  'zh-CN': zhQuotes,
  'en-US': enQuotes,
  'ja-JP': jaQuotes,
  'es-ES': esQuotes,
  'fr-FR': frQuotes,
  'de-DE': deQuotes,
  'ko-KR': koQuotes,
  'pt-BR': ptQuotes,
  'ru-RU': ruQuotes,
  'it-IT': itQuotes
}

// Supported languages list
export const supportedLanguages = [
  'zh-CN', 'en-US', 'ja-JP', 'es-ES', 'fr-FR', 
  'de-DE', 'ko-KR', 'pt-BR', 'ru-RU', 'it-IT'
]

// Dynamic loader function (for future use if needed)
export { loadQuotes }